import VirtualOffice from "../../modules/virtual-office/views/VirtualOffice.vue";
import RouterViewRender from "../../utils/routes/router-view-render";

const VirtualOfficeRoutes = {
  path: "consultorio-virtual",
  component: RouterViewRender,
  children: [
    {
      path: "",
      component: VirtualOffice,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default VirtualOfficeRoutes;
